import type { Translations } from '../../server/chat';

export const translations: Translations = {
	name: "Turkish",
	strings: {
		"Please follow the rules:": "Lütfen kurallara uyun:",
		"[TN: Link to the PS rules for your language (path after pokemonshowdown.com]/rules": "/pages/rules-tr",
		"Global Rules": "Genel kurallar",
		"${room} room rules": "${room} odası kuralları",
	},
};
